import Typography from '@/ui/components/typography'
import { styled } from '@mui/system'

export const HeaderText = styled(Typography)<{ padding?: string }>`
    margin: 12px 0;
    padding: ${({ padding }) => padding};
`

export const Cell = styled('div')<{
    padding?: string
}>`
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: ${({ padding }) => padding || '20px 0'};

    .table-cell-text {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        white-space: normal;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .capitalize {
        text-transform: capitalize;
    }
`
